import React, { useEffect, useState } from 'react'
import { PropTypes } from 'prop-types'
import TableRow from './TableRow'
import TableHeadItem from './TableHead'
import { css, StyleSheet } from 'aphrodite'
import { COLOR_BLACK, COLOR_WHITE, COLOR_GRAY__600 } from '../../../lib/colors'
import UIButton from '../../UI/UIButton'
import { useTranslation } from 'react-i18next'

const styles = StyleSheet.create({
  containerTitle: {
    backgroundColor: COLOR_WHITE,
    padding: '20px 20px',
  },
  title: {
    color: COLOR_BLACK,
    fontWeight: 700,
  },
  table: {
    borderCollapse: 'collapse',
    width: '100%',
  },
  paginationContainer: {
    backgroundColor: 'white',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  numberResult: {
    margin: 0,
    padding: '16px 24px',
    fontSize: '14px',
    color: COLOR_GRAY__600,
  },
  paginationButton: {
    padding: '16px 24px',
    display: 'flex',
    gap: '16px',
  },
})

const WidgetTable = ({
  title,
  theadData,
  tbodyData,
  id = '',
  totalResult = 0,
  hasNextPage = false,
  hasPreviousPage = false,
  onClickNext,
  onClickPrevious,
}) => {
  const { t } = useTranslation('translation')
  const [resultRow, setResultRow] = useState(10)

  useEffect(() => {
    if (totalResult < 10) setResultRow(totalResult)
  }, [totalResult])

  return (
    <>
      <div className={css(styles.containerTitle)}>
        <span className={css(styles.title)}>{title}</span>
      </div>
      <table className={css(styles.table)} id={id}>
        <thead>
          <tr>
            {theadData?.map((h, index) => {
              return <TableHeadItem key={index} item={h} />
            })}
          </tr>
        </thead>
        <tbody>
          {tbodyData?.map((item) => {
            return <TableRow key={item.id} data={item.items} />
          })}
        </tbody>
      </table>
      {tbodyData?.length > 0 && (
        <div className={css(styles.paginationContainer)}>
          <p className={css(styles.numberResult)}>
            {t('resultNumber', { resultRow, totalResult })}
          </p>
          <div className={css(styles.paginationButton)}>
            {hasPreviousPage && (
              <UIButton
                design="tertiaryLight"
                onClick={onClickPrevious}
                withBackwardChevron
                label={t('common.button.previousPage')}
              />
            )}
            {hasNextPage && (
              <UIButton
                design="tertiaryLight"
                onClick={onClickNext}
                withForwardChevron
                label={t('common.button.nextPage')}
              />
            )}
          </div>
        </div>
      )}
    </>
  )
}

WidgetTable.propTypes = {
  title: PropTypes.string,
  theadData: PropTypes.array,
  tbodyData: PropTypes.array,
  id: PropTypes.string,
  totalResult: PropTypes.number,
  hasNextPage: PropTypes.bool,
  hasPreviousPage: PropTypes.bool,
  onClickNext: PropTypes.func,
  onClickPrevious: PropTypes.func,
}

export default WidgetTable
